let MD5Lib = require('blueimp-md5')

export function createPassword(str) {
  let newPassword = str + str.substring(str.length - 4, str.length);
  var hash = MD5Lib(newPassword);

  return hash.toString();
}